import component from './form.vue'

export default component